import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/Icon_WallCat.png'
import _imports_1 from '../assets/WallCat_GPLAY_Guide_1.png'
import _imports_2 from '../assets/WallCat_GPLAY_Guide_2.png'
import _imports_3 from '../assets/WallCat_GPLAY_Guide_3.png'
import _imports_4 from '../assets/Screenshot_WallCat_1.png'
import _imports_5 from '../assets/Screenshot_WallCat_2.png'
import _imports_6 from '../assets/Screenshot_WallCat_3.png'
import _imports_7 from '../assets/Screenshot_WallCat_4.png'
import _imports_8 from '../assets/Screenshot_WallCat_5.png'
import _imports_9 from '../assets/Screenshot_WallCat_6.png'
import _imports_10 from '../assets/Screenshot_WallCat_7.png'
import _imports_11 from '../assets/Screenshot_WallCat_8.png'
import _imports_12 from '../assets/Screenshot_WallCat_9.png'
import _imports_13 from '../assets/Screenshot_WallCat_10.png'
import _imports_14 from '../assets/Screenshot_WallCat_11.png'
import _imports_15 from '../assets/Screenshot_WallCat_12.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_column = _resolveComponent("ion-column")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("WallCat", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("WallCat", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "bannerColumn" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "icon"
                      }, null, -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "auto",
                    class: "description-column"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { style: {"padding":"0px","margin":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, { style: {"padding":"0px","margin":"0px"} }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createElementVNode("p", {
                                class: "size-appname",
                                style: {"padding":"0px","margin":"0px"}
                              }, [
                                _createElementVNode("strong", null, "WallCat")
                              ], -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("p", { class: "size-appname-icon" }, "version 1.0.1", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.logoAndroid,
                                class: "size-appname-icon"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        href: "https://f2.puffercat.xyz/PuffercatApps/WallCat-1.0.1.apk",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"},
                        download: "WallCat-latest.apk"
                      }, {
                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                          _createTextVNode("Download", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        id: "alternateMirrors_WallCat",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"}
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Alternate mirrors", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-extension" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        id: "googlePlayEA_WallCat",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"}
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode("Google Play", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        href: "https://pfr.cat/out/hwwc?utm_source=puffercatapps",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"}
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("Huawei AppGallery", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_modal, {
                ref: "modal",
                trigger: "alternateMirrors_WallCat"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, null, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("Alternate mirrors", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
                              }, {
                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                  _createTextVNode("Close", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_content, { class: "ion-padding" }, {
                    default: _withCtx(() => [
                      _cache[47] || (_cache[47] = _createElementVNode("h2", { style: {"padding-left":"30px"} }, "WallCat 1.0.1", -1)),
                      _createVNode(_component_ion_label, {
                        color: "medium",
                        class: "tableLabel checksum",
                        style: {"padding-left":"30px"}
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("SHA256 Checksum: 14e8a11e5d5c7fcee7fd9bc3cda1e0fd838f8de8fad2b76ceed1adfd42c8904d", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list, {
                        inset: true,
                        style: {"border-radius":"25px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createElementVNode("a", { href: "https://f2.puffercat.xyz/PuffercatApps/WallCat-1.0.1.apk" }, "🇩🇪 2.puffercat.xyz - Contabo (Default)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createElementVNode("a", { href: "https://cdn.puffercat.xyz/c/puffercat-apps/apks/WallCat/WallCat-1.0.1.apk" }, "🇳🇱 puffercat.xyz - DigitalOcean", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                  _createElementVNode("a", { href: "https://deimos.pufferc.at/mirror/WallCat-1.0.1.apk" }, "🇸🇪 deimos.pufferc.at - aeza", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                  _createElementVNode("a", { href: "https://c.wadowice.ovh/index.php/s/wallcat101" }, "🇵🇱 wadowice.ovh - My home (pls dont ddos 🥺)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                  _createElementVNode("a", { href: "https://www.icloud.com/iclouddrive/0d2SL-WxHw7dBwlV_t5ZPAEpQ#WallCat-1.0" }, "iCloud Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                  _createElementVNode("a", { href: "https://1drv.ms/u/c/c6bbfc602e5efcd0/IQBctXMDf9yJRoDbmIFGm-KPAfPU47FnwZOhblk60lZ9yas?e=pGD23i" }, "OneDrive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createElementVNode("a", { href: "https://drive.google.com/file/d/1AWPu8U4ovSQxka88Bh_NA3CSlgMEfL2I/view?usp=share_link" }, "Google Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                  _createElementVNode("a", { href: "https://pan.baidu.com/s/1D6vWEnmzL_i0YZlrLyTwYw?pwd=wall" }, "百度网盘 (提取码：wall)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                  _createElementVNode("a", { href: "https://disk.yandex.ru/d/9VehTxAMUmrfzQ" }, "Яндекс Диск", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                  _createElementVNode("a", { href: "https://www.dropbox.com/scl/fi/hcr8w738c097i8ezm137s/WallCat-1.0.1.apk?rlkey=l13twc95c14tzsnk7zge2ng25&e=1&st=mq0thlil&bmus=1&dl=0" }, "Dropbox", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                  _createElementVNode("a", { href: "https://app.box.com/s/ccbob8n62hjp10pztr2yp9kxk11fqtsf" }, "Box", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                  _createElementVNode("a", { href: "https://drive.proton.me/urls/0DK70Z0W8W#N2nfQutAxaGU" }, "Proton Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                  _createElementVNode("a", { href: "https://pan.xunlei.com/s/VOqblom-krpxYVdRXssZoIKpA1?pwd=hwqu" }, "迅雷云盘 (提取码：hwqu)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createElementVNode("a", { href: "https://1024terabox.com/s/1boNL4z2-cHZ7ddda1QykVg" }, "Terabox", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                  _createElementVNode("a", { href: "https://mega.nz/file/KtIRhZpC#YlAZsk1KiVVX_3QfIzokjDIFk0-7KPxgyM3QR4T_Dy8" }, "MEGA", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                  _createElementVNode("a", { href: "https://pan.quark.cn/s/ffaf9a924042" }, "夸克网盘", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _cache[48] || (_cache[48] = _createElementVNode("h2", { style: {"padding-left":"30px"} }, "WallCat 1.0.0", -1)),
                      _createVNode(_component_ion_label, {
                        color: "medium",
                        class: "tableLabel",
                        style: {"padding-left":"30px"}
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("SHA256 Checksum: b1159ec3a89e5bce08df76a8c7a151d8a7965ddbcc868be7ab0392ff08e3e6db", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list, {
                        inset: true,
                        style: {"border-radius":"25px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                  _createElementVNode("a", { href: "https://f2.puffercat.xyz/PuffercatApps/WallCat-1.0.apk" }, "🇩🇪 2.puffercat.xyz - Contabo (Default)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                  _createElementVNode("a", { href: "https://cdn.puffercat.xyz/c/puffercat-apps/apks/WallCat/WallCat-1.0.apk" }, "🇳🇱 puffercat.xyz - DigitalOcean", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                  _createElementVNode("a", { href: "https://deimos.pufferc.at/mirror/WallCat-1.0.apk" }, "🇸🇪 deimos.pufferc.at - aeza", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                  _createElementVNode("a", { href: "https://c.wadowice.ovh/index.php/s/wallcat10" }, "🇵🇱 wadowice.ovh - My home (pls dont ddos 🥺)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                  _createElementVNode("a", { href: "https://www.icloud.com/iclouddrive/071WiIXKqfEbErB8uwMpQsZ_A#WallCat-1" }, "iCloud Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                  _createElementVNode("a", { href: "https://1drv.ms/u/c/c6bbfc602e5efcd0/Eafn9A-CP-pFrxUdxGdbMLEBdyDYUO_S0fmiNEKWMdRrNQ" }, "OneDrive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                  _createElementVNode("a", { href: "https://drive.google.com/file/d/1dNoPjL0bPx5ewFl61vpQanHHPBflsWdL/view?usp=share_link" }, "Google Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                  _createElementVNode("a", { href: "https://pan.baidu.com/s/1e_aJvbCUZthaGvBFOS5HhA?pwd=wall" }, "百度网盘 (提取码：wall)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                  _createElementVNode("a", { href: "https://disk.yandex.ru/d/vA-UW4VqIEx5Wg" }, "Яндекс Диск", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                  _createElementVNode("a", { href: "https://www.dropbox.com/scl/fi/19gutjtv8gson039k4akh/WallCat-1.0.apk?rlkey=mpgdljgz4mgf9ydp1zsp4tpz6&st=uoh44c0i&dl=0" }, "Dropbox", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                  _createElementVNode("a", { href: "https://app.box.com/s/q8pdckfn4ltdkrw8w4ybeq0wysx12m5g" }, "Box", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                  _createElementVNode("a", { href: "https://drive.proton.me/urls/2QBSGT252R#le16Bsi3CqlN" }, "Proton Drive", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                  _createElementVNode("a", { href: "https://pan.xunlei.com/s/VOP62jYPNlevTgYvIlxZ-mznA1?pwd=dexu" }, "迅雷云盘 (提取码：dexu)", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                  _createElementVNode("a", { href: "https://1024terabox.com/s/1pKUQkFv9ttsFOc2EgXy5Lw" }, "Terabox", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                  _createElementVNode("a", { href: "https://mega.nz/file/DwxnwLIS#BQwbFp9QZlT25Lb476UJX6__9-XCwTJd1VfHJ5hnFTo" }, "MEGA", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                  _createElementVNode("a", { href: "https://pan.quark.cn/s/4944d7713e68" }, "夸克网盘", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512),
              _createVNode(_component_ion_modal, {
                ref: "modal2",
                trigger: "googlePlayEA_WallCat"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_toolbar, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_title, null, {
                            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                              _createTextVNode("Google Play Early Access", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismiss2()))
                              }, {
                                default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                  _createTextVNode("Close", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_content, { class: "ion-padding" }, {
                    default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                      _createElementVNode("p", { class: "guideTextRegular" }, "Due to Google's \"production application\" requirements, this app is not yet able to be published on Google Play. You can join the closed testing program to access the app now and help fulfill the requirements to get fully published.", -1),
                      _createElementVNode("div", { class: "guideNumberBackground" }, "1", -1),
                      _createElementVNode("div", { class: "guideSectionContainer" }, [
                        _createElementVNode("div", { class: "guideSectionLineContainer" }, [
                          _createElementVNode("div", { class: "guideSectionline" })
                        ]),
                        _createElementVNode("div", { class: "guideSectionContent" }, [
                          _createElementVNode("p", { class: "guideTextRegular" }, [
                            _createTextVNode("Join "),
                            _createElementVNode("a", { href: "https://groups.google.com/g/pfrmedia-beta" }, "this"),
                            _createTextVNode(" Google group. Make sure you're using the same Google account as the one you'll download the app on.")
                          ]),
                          _createElementVNode("img", {
                            src: _imports_1,
                            class: "guideImage"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "guideNumberBackground" }, "2", -1),
                      _createElementVNode("div", { class: "guideSectionContainer" }, [
                        _createElementVNode("div", { class: "guideSectionLineContainer" }, [
                          _createElementVNode("div", { class: "guideSectionline" })
                        ]),
                        _createElementVNode("div", { class: "guideSectionContent" }, [
                          _createElementVNode("p", { class: "guideTextRegular" }, [
                            _createTextVNode("Go "),
                            _createElementVNode("a", { href: "https://play.google.com/store/apps/details?id=xyz.puffercat.wallcat" }, "here"),
                            _createTextVNode(" to download the app. Ensure the account you're using on Google Play is the same one you joined the group on.")
                          ]),
                          _createElementVNode("img", {
                            src: _imports_2,
                            class: "guideImage"
                          })
                        ])
                      ], -1),
                      _createElementVNode("div", { class: "guideNumberBackground" }, "3", -1),
                      _createElementVNode("div", { class: "guideSectionContainer" }, [
                        _createElementVNode("div", { class: "guideSectionLineContainer" }, [
                          _createElementVNode("div", { class: "guideSectionline" })
                        ]),
                        _createElementVNode("div", { class: "guideSectionContent" }, [
                          _createElementVNode("p", { class: "guideTextRegular" }, "Please use the \"Private feedback to developer\" function to help the app get published (Google uses this as a metric of app's production readiness)"),
                          _createElementVNode("img", {
                            src: _imports_3,
                            class: "guideImage"
                          })
                        ])
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Changelog - 1.0.1")
                      ], -1),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, "Updated Frames dashboard from v3.6.2 to v3.7.0"),
                        _createElementVNode("li", null, "First release on Google Play and AppGallery"),
                        _createElementVNode("li", null, "Last release to support Android 5 due to Frames dashboard dropping Android 5 in version 3.7.1 :(")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Description")
                      ], -1),
                      _createTextVNode(" A wallpaper app by Puffercat", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" Includes collections:", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Smudges", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Landscapes", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Waves", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Beam", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Glass", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Depth", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Flat shapes", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Photo", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Aurora", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" • Glow", -1),
                      _createElementVNode("br", null, null, -1),
                      _createTextVNode(" As well as some wallpapers I made for my other projects", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Screenshots")
                      ], -1),
                      _createElementVNode("div", { class: "scrollScreenshots" }, [
                        _createElementVNode("img", {
                          src: _imports_4,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_5,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_6,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_7,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_8,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_9,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_10,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_11,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_12,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_13,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_14,
                          class: "screenshot"
                        }),
                        _createElementVNode("img", {
                          src: _imports_15,
                          class: "screenshot"
                        })
                      ], -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                      _createElementVNode("h4", null, [
                        _createElementVNode("strong", null, "Links")
                      ], -1),
                      _createElementVNode("a", {
                        href: "https://wallcat.app?utm_source=PuffercatApps",
                        class: ""
                      }, "Website", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "mailto:meow@wallcat.app",
                        class: ""
                      }, "E-mail", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", {
                        href: "https://twitter.com/WallCatApp",
                        class: ""
                      }, "Twitter", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", { href: "https://wallcat.app/privacy" }, "Privacy Policy", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("a", { href: "https://wallcat.app/tos" }, "Terms of Service", -1),
                      _createElementVNode("br", null, null, -1),
                      _createElementVNode("br", null, null, -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}